exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-gray{\n    color:gray;\n}\n.active{\n    color:red;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/edit-product/edit-product.component.css
// module id = ../../../../../src/app/components/edit-product/edit-product.component.css
// module chunks = main